import React, { useEffect } from "react";
// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";
// import styles bundle
import "swiper/css/bundle";
import "./TestimonialSlider.css";
import TestimonialData from "./TestimonialData";
import SectionTitle from "../Utilities/SectionTitle";
import ConstantHelper from "../../Helpers/ConstantHelper";

const TestimonialSlider = () => {
  useEffect(() => {
    const swiper = new Swiper(".swiper-container", {
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 2.3,
      loop: true,
      spaceBetween: 30,
      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        depth: 800,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: { delay: 5000 },
    });

    const queryResizer = () => {
      if (window.innerWidth < 724) swiper.params.slidesPerView = 2;
      if (window.innerWidth > 501) swiper.params.slidesPerView = 2;
      if (window.innerWidth > 724) swiper.params.slidesPerView = 2.3;
      if (window.innerWidth < 501) swiper.params.slidesPerView = 1.5;
      swiper.update();
    };

    window.onresize = queryResizer;
    queryResizer();
  }, []);

  return (
    <div className="testimonial-main">
      <div className="row d-flex justify-content-center title">
        <div className="menu-content col-lg-12">
          <div className="title text-center">
            <h1 className="mb-10">{ConstantHelper.TestimonialSectionTitle}</h1>
          </div>
        </div>
      </div>
      <div id="craouselContainer" className="swiper-container">
        <div className="swiper-wrapper" id="slideHolder">
          {TestimonialData?.map((item, index) => (
            <div className="swiper-slide" key={index}>
              <div className="ImgHolder">
                <img src={item.avatar} alt={item.name} />
              </div>
              <div className="ContentHolder">
                <h3>{item.name}</h3>
                <p>{item.review}</p>
              </div>
            </div>
          ))}
        </div>
        <a
          className="write-review-button"
          href={ConstantHelper.goolgeReviewUrl}
          target="_blank"
        >
          {ConstantHelper.WriteReviewButton}
        </a>
        {/* <div className="swiper-pagination"></div> */}
      </div>
    </div>
  );
};

export default TestimonialSlider;
